import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API, PHOTO_POOL, resolveImage } from "../data/site";

export const usePhotoPool = () => {
  const { data } = useQuery({
    queryKey: ["pool-photos"],
    queryFn: async () => (await axios.get(`${API}/pool-photos`)).data,
    staleTime: 60000,
  });
  const extra = (data || []).map((p) => resolveImage(p.url));
  return extra.length ? extra : PHOTO_POOL;
};

const CyclingImage = ({ start = 0, interval = 6000, alt = "On Point Homes — Idaho home builder", className = "" }) => {
  const pool = usePhotoPool();
  const [i, setI] = useState(start);

  useEffect(() => {
    pool.forEach((src) => { const img = new Image(); img.src = src; });
  }, [pool.length]);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % pool.length), interval);
    return () => clearInterval(t);
  }, [interval, pool.length]);

  const current = pool[i % pool.length];

  return (
    <div className={`absolute inset-0 ${className}`}>
      <AnimatePresence>
        <motion.img
          key={current}
          src={current}
          alt={alt}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.4, ease: "easeInOut" }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>
    </div>
  );
};

export default CyclingImage;
